import { Callout } from "@radix-ui/themes";
import FontAwesome from "../utilities/FontAwesome";
import MailToLink from "../misc/MailToLink";
import { useStores } from "../../stores/useStores";
import { useFeatureFlags } from "../../utils/featureFlags/useFeatureFlags";

export function useMessagingNotEnabledCallout() {
  const { show_two_way_messaging } = useFeatureFlags();
  const { organizationStore, userStore } = useStores();

  return (
    show_two_way_messaging &&
    !organizationStore.organization.billing_products?.messaging &&
    (organizationStore.organization.user_roles.is_staff || userStore.isAdmin)
  );
}

export function MessagingNotEnabledCallout() {
  return (
    <Callout.Root color={"red"}>
      <Callout.Icon>
        <FontAwesome prefix={"fas"} name={"fa-info-circle"} />
      </Callout.Icon>
      <Callout.Text>
        Sending two-way communications is not supported for this site. Please
        contact support at{" "}
        <MailToLink recipient={"support@schoolblocks.com"}>
          support@schoolblocks.com
        </MailToLink>{" "}
        to learn more!
      </Callout.Text>
    </Callout.Root>
  );
}
